<template>
  <div>
    <div
      class="group-order-selection"
      :class="{ 'is-bordered': !confirmWithSuccess }"
    >
      <div class="subheading">
        <p>
          <strong>
            {{
              selectedVariants.length === 1
                ? 'Your selection'
                : 'Your selections'
            }}
          </strong>
        </p>
        <button
          v-if="!confirmWithSuccess"
          class="whitebutton-gemnote whitebutton-gemnote--tiny"
          @click="editItemsSelection"
        >
          <span>Edit</span>
        </button>
      </div>
      <table>
        <thead>
          <tr>
            <th class="product-header">Product</th>
            <th class="product-title">Product Title</th>
            <th class="product-size">Size</th>
            <th class="product-quantity">Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(variant, index) in selectedVariants" :key="index">
            <td>
              <img :src="photoURL(variant)" />
            </td>
            <td>{{ variant.productVariantAttributes.productName }}</td>
            <td>
              {{ handleSize(variant) }}
            </td>
            <td>{{ variant.productVariantQty }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="align-right" v-if="!confirmWithSuccess">
      <button
        class="button-gemnote button-gemnote--small"
        :class="{ 'button-gemnote--disabled': isConfirming }"
        :disabled="isConfirming"
        v-if="selectedVariants.length"
        @click="confirmOrder"
      >
        <span>Confirm order</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { scrollPageToTop, defaultNotFoundImage } from '../../helpers'

export default {
  name: 'GroupOrderCartList',
  props: {
    selectedVariants: {
      type: Array,
      required: true
    },
    confirmWithSuccess: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    photoURL(variant) {
      return variant && variant.productVariantAttributes
        ? variant.productVariantAttributes.representative_images
        : defaultNotFoundImage
    },
    editItemsSelection() {
      this.$router.push({ name: 'GroupOrderTierList' })
    },
    confirmOrder() {
      this.$store.dispatch('groupOrder/confirmRecipientGroupOrder')
      scrollPageToTop()
    },
    handleSize(data) {
      if (data.productVariantAttributes.spec.size) {
        if (data.productVariantAttributes.spec.size.name) {
          return data.productVariantAttributes.spec.size.name
        } else {
          return data.productVariantAttributes.spec.size
        }
      } else {
        return ''
      }
    }
  },
  computed: {
    ...mapState({
      isConfirming: state => state.groupOrder.isConfirming
    })
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.whitebutton-gemnote {
  height: 1.875rem;
  font-size: 0.875rem;
  width: auto;
  padding: 0 1.5rem;
  font-weight: normal;
}

.button-gemnote {
  width: auto;
  height: 2.5rem;
  padding: 0 1.5rem;
  margin-top: 2rem;
}
.group-order-selection {
  margin-top: 2rem;
  padding: 2rem 3rem;
  overflow-x: auto;

  &.is-bordered {
    border: 1px solid #232220;
  }

  .subheading {
    display: flex;
    justify-content: space-between;
    p {
      font-size: 0.875rem;
      text-align: left;
    }
  }
}

table {
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 3rem;
  border-spacing: 0px;
  border-collapse: separate;
  & thead > tr > th {
    font-size: 0.813rem;
    padding: 1rem;
    border-bottom: 1px solid $onyx;
  }
  & tbody > tr > td {
    padding: 0.5rem;
    font-size: 0.813rem;
    border-bottom: 1px solid $onyx;
  }
  & tbody > tr > td:nth-child(2) {
    text-align: left;
    cursor: pointer;
  }
  & tfoot > tr > td {
    padding-top: 3rem;
  }
  & tfoot > tr > td:nth-child(4) {
    font-weight: 600;
  }
  .product-header {
    width: 20%;
  }
  .product-title {
    width: 35%;
    text-align: left;
  }
}

img {
  width: 100px;
  height: 100px;
  max-width: 100%;
  object-fit: scale-down;
  cursor: pointer;
}

@media (max-width: 1100px) {
  .group-order-selection {
    padding: 2rem;
  }
}
</style>
